<template>
  <div class="cinema-banner-wrap">
    <ul class="cinema-list">
      <li v-for="item in banner" :key="item.bannerId" class="cinema-banner-item" @click="navigateBanner(item.actionType, item.actionData)">
        <div class="name">
          <span class="title">{{item.name}}</span>
          <span class="icon">影院券</span>
        </div>
        <div class="type">{{item.masterTitle}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { resolveActionPath } from "../../../util/function";
export default {
  props: ["banner"],
  data() {
    return {}
  },
  mounted() {
    console.log(111)
  },
  methods: {
    navigateBanner(type, data) {
      let action = resolveActionPath({actionType: type, actionData: data})
      if(action){
          this.$router.push(action)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../stylesheet/variable.less";
.cinema-banner-wrap {
  .cinema-list {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      padding: 15px;
      position: relative;
      background-color: #fff;
      &:after {
        .setBottomLine();
      }
      .name {
        font-size: 15px;
        color: #18191a;
        position: relative;
        .icon {
          // display: inline-block;
          color: #ffb245;
          margin-left: 7px;
          font-size: 10px;
          padding: 0 6px;
          // position: relative;
          text-align: center;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          &:after {
            .setBorderLine(#ffb245);
          }
        }
      }
      .type {
        margin-top: 5px;
        font-size: 13px;
        color: #797d82;
      }
    }
  }
}
</style>

